import Cookies from 'js-cookie'
import { getAccountLink, getOrdersLink, getWalletLink } from '../useLinks'

export function isLegalProfile(): boolean {
    return getCondaUserProfile() === 'company'
}

export function isNaturalProfile(): boolean {
    return getCondaUserProfile() === 'personal'
}

export function getCondaUserProfile(): null | 'personal' | 'company' {
    return Cookies.get('conda_user_profile')
}

export function setUserProfileCookie(userProfileType: 'company' | 'personal'): void {
    Cookies.set('conda_user_profile', userProfileType, {
        path: '/',
        domain: window.location.hostname,
    })
}

export function switchToLegalProfile(page?: string | null): void {
    setUserProfileCookie('company')
    if (page) {
        navigateToSelectedPage(page)
    } else {
        window.location.reload()
    }
}

export function switchToNaturalProfile(page?: string | null): void {
    setUserProfileCookie('personal')
    if (page) {
        navigateToSelectedPage(page)
    } else {
        window.location.reload()
    }
}

function navigateToSelectedPage(page: string | null): void {
    switch (page) {
        case 'account':
            window.location.replace(getAccountLink())
            break
        case 'orders':
            window.location.replace(getOrdersLink())
            break
        case 'wallet':
            window.location.replace(getWalletLink())
            break
        default:
            window.location.reload()
    }
}
